/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Container, Card } from 'reactstrap';

import Image from 'Components/Image';

import Utils from 'Lib/Utils';
import NavActions from 'Services/Navigation/Actions';

import Selectors from 'Redux/Selectors';

import { RootState } from 'Redux/store';
import { IAddToCartThunkParams } from 'Redux/slices/cart/controllers/addToCart';
import Actions from 'Redux/Actions';
import { IProduct } from '@ddot/AddToCartCommon/lib/entities';
import LoginOrSignupModal from '../../User/LoginSignUpModal';
import { productImg, productName, productPrice, productItem, wishListButton } from '../Styles/ProductsRowStyles';

interface ProductProps {
    // productDetails: IProductDetails;
    loading: boolean;
    error: string;
    wishlist: IProduct[];
    // goldPrice: IGoldPrice;
    clearError(): void;
    addToWishlistLocalWeb(product: IProduct): void;
    addToCart(item: IAddToCartThunkParams): void;
    isLoggedIn: string | undefined;
    getWishlist(): void;
    removeFromWishlistLocalWeb(product: IProduct): void;
    product: IProduct;
    type: string;
}

const FeaturedProduct = (props: ProductProps) => {
    const { loading, error, wishlist, product, type, isLoggedIn, getWishlist, removeFromWishlistLocalWeb, addToCart, clearError } = props;
    const { imageUrl, name, id, currency, imageFileNames } = product;

    const [wishListHover, setWishListHover] = useState(false);
    const goldPrice = useSelector(Selectors.getHomeGoldPrice);

    const { minPrice, maxPrice } = Utils.Jemisys.getItemPriceRange(product, goldPrice);

    const [loginModalVisible, setLoginModalVisible] = useState(false);

    const getImageFile = () => {
        if (imageFileNames && imageFileNames.length) {
            return imageFileNames[0];
        }
        if (imageUrl && imageUrl.length) {
            return imageUrl[0];
        }
        return '';
    };

    useEffect(() => {
        return () => {
            clearError();
        };
    }, []);

    const onPressed = () => {
        if (wishListHover) {
            onWishlistHover();
            return;
        }
        window.scrollTo(0, 0);
        NavActions.navToProductDetails(id);
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(false);
    };

    const onAddToWishlist = () => {
        const { addToWishlistLocalWeb } = props;

        if (isLoggedIn) {
            if (wishlist.includes(product)) {
                removeFromWishlistLocalWeb(product);
            } else addToWishlistLocalWeb(product);
        } else setLoginModalVisible(true);
    };

    const onWishlistHover = () => {
        onAddToWishlist();
    };

    return (
        <Card
            css={productItem}
            onClick={onPressed}
        >
            <Container fluid>
                {
                    type === 'list' && (
                        <div style={{ position: 'relative', flex: 1 }}>
                            <div
                                role='button'
                                tabIndex={0}
                                onMouseEnter={() => setWishListHover(true)}
                                onMouseLeave={() => setWishListHover(false)}
                                css={wishListButton}
                            >
                                {
                                    wishlist.includes(product)
                                        ? (
                                            <img src='/assets/icons/LikeFill.png' alt='' style={{ height: 30, width: 30, objectFit: 'contain', marginTop: 10, marginRight: 10 }} />
                                        ) : (
                                            <img src='/assets/icons/LikeProduct.svg' alt='' style={{ height: 30, width: 30, objectFit: 'contain', marginTop: 10, marginRight: 10 }} />
                                        )
                                }
                            </div>
                            <Image
                                css={productImg}
                                url={getImageFile()}
                                alt='Product Img'
                            />
                        </div>
                    )
                }

                {
                    type === 'detail' && (
                        <Image
                            css={productImg}
                            url={getImageFile()}
                            alt='Product Img'
                        />

                    )
                }

                <div css={productName}>{name}</div>

                <div css={productPrice}>
                    {maxPrice !== minPrice ? `${currency} ${minPrice} -` : ''}

                    {`${currency} ${maxPrice}`}
                </div>
            </Container>

            <LoginOrSignupModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
            />
        </Card>
    );
};

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getCartAddToCartAttempting(state),
    error: Selectors.getCartAddToCartError(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
    wishlist: Selectors.getUserWishlist(state),
    isLoggedIn: Selectors.getAuthAuthToken(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    addToCart: (item: IAddToCartThunkParams) => dispatch(Actions.cartAddToCart(item)),
    addToWishlistLocalWeb: (product: IProduct) => dispatch(Actions.userAddToWishListLocalWeb({ product })),
    clearError: () => dispatch(Actions.cartClearAddToCartError()),
    getWishlist: () => dispatch(Actions.userGetWishlistLocalWeb()),
    removeFromWishlistLocalWeb: (product: IProduct) => dispatch(Actions.userRemoveFromWishlistLocalWeb({ product })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProduct);
